/**
 * Enum.ts
 * This component is used to define common variables that will be utilized throughout the project.
 */

import { reject } from "lodash";

// Enums for Table Type
export enum eTableType {
  ROW = 1,
  COLUMN = 2,
}

export enum eDocType {
  AADHAR = 1,
  PASSPORTSIZEPHOTO = 2,
  OTHER = 3,
}

// Constants for Input Lengths
export const INPUT_LENGTH = {
  PASSWORD_LENGTH: 20,
  EMAIL_LENGTH: 40,
  BASIC_LENGTH: 30,
  DISPLAY_LENGTH: 15,
  ADDRESS_LENGTH: 80,
  PINCODE_LENGTH: 10,
  TEXTAREA_LENGTH: 400,
};

// Enums for Result Codes
export enum eResultCode {
  SUCCESS = 0,
  DB_ERROR = 1,
  NO_DATA_FOUND = 2,
  AUTHENTICATION_FAILED = 3,
  UNAUTHORIZED = 4,
  UNKNOWN = 5,
  INVALID_LOGIN_ID = 6,
  INVALID_PASSWORD = 7,
  SERVICE_ERROR = 8,
  INVALID_REQUEST = 9,
  NOT_FOUND = 10,
  NETWORK_ERRORSERVEERROR = 11,
  CREATED = 12,
  INTERNAL_SERVEERROR = 13,
  UNUSED = 14,
  MULTIPLE_RECORDS = 15,
  BAD_REQUEST = 16,
  R_DUPLICATE = 25,
}

// Enums for Fetch Policy
export enum eFetchPolicy {
  CACHE_FIRST = "cache-first",
  NETWORK_ONLY = "network-only",
  CACHE_ONLY = "cache-only",
  NO_CACHE = "no-cache",
  STANDBY = "standby",
  CACHE_AND_NETWORK = "cache-and-network",
}
// Enums for HTTP Status Codes
export enum eHTTPStatusCode {
  OK = 200,
  BAD_REQUEST = 400,
  INTERNAL_SERVER_ERROR = 500,
}

// Enums for Login Modes
export enum eLoginMode {
  PASSWORD = 1,
  OTP = 2,
}
// Enums for User Types
export enum eUserType {
  USER = 1,
  ADMIN = 2,
}

// Enums for File Types
export enum eFileType {
  JPEG = ".jpeg",
  PNG = ".png",
  PDF = ".pdf",
  JPG = ".jpg",
}

export const eSendAlertType = {
  EMAIL: 1,
  SMS: 2,
  EMAILANDSMS: 3,
};

// Enums for Content Types
export enum eContentType {
  IMAGE = "image/jpeg",
  PDF = "application/pdf",
  OCTETSTREAM = "application/octet-stream",
}

export enum eORGANIZATION {
  CUSTOMER = "CUSTOMER",
  IDEX = "IDEX",
  SERVICEPARTNER = "SERVICEPARTNER",
  DEALER = "DEALER",
}

export enum eTICKETSTATUS {
  INPROGRESS = "IN PROGRESS",
  VISITSCHEDULED = "VISIT SCHEDULED",
  HOLDDELIVERYDEPENDENCY = "HOLD - DEALER DEPENDENCY",
  HOLDSPAREDEPENDENCY = "HOLD - SPARE DEPENDENCY",
  CLOSE = "CLOSE",
  UNASSIGNED = "UNASSIGNED",
  SERVICEENGINEERASSIGNED = "SERVICE ENGINEER ASSIGNED",
  HOLDSPAREAPPROVALPENDING = "Hold - Spares approval pending",
  HOLDAMCAPPROVALPENDING = "Hold - AMC approval pending",
}

export enum eCustomDropdownType {
  SCROLLER = "SCROLLER",
  BUTTON = "BUTTON",
}

export enum eTICKETSTATUSCOLORS {
  INPROGRESS = "#F2A900",
  VISITSCHEDULED = "#0063BF",
  HOLDDELIVERYDEPENDENCY = "#004280",
  HOLDSPAREDEPENDENCY = "#323A40",
  CLOSE = "#000000",
  UNASSIGNED = "#521F04",
  SERVICEENGINEERASSIGNED = "#EB5A0C",
  HOLDSPAREAPPROVALPENDING = "#660E1D",
  HOLDAMCAPPROVALPENDING = "#593E00",
  DEFAULT = "#333333",
}

export enum ePrivileges {
  // DASHBOARD MODULE
  VIEWDASHBOARD = "VIEWDASHBOARD",
  // CUSTOMER MODULE
  VIEWCUSTOMER = "VIEWCUSTOMER",
  ADDCUSTOMERS = "ADDCUSTOMERS",
  EDITCUSTOMERS = "EDITCUSTOMERS",
  DELETECUSTOMERS = "DELETECUSTOMERS",
  EDITCUSTCODE = "EDITCUSTCODE",
  EDITDAYSTARTEND = "EDITDAYSTARTEND",

  // SERVICE PARTNER MODULE
  ADDPARTNERS = "ADDPARTNERS",
  EDITPARTNERS = "EDITPARTNERS",
  DELETEPARTNERS = "CHANGEPARTNERSTATUS",
  VIEWSERVICEPARTNER = "VIEWSERVICEPARTNER",
  BULKUPLOADENGINEERS = "BULKUPLOADENGINEERS",
  MAPCUSTPARTNER = "MAPCUSTPARTNER",
  MAPDEALERENGG = "MAPDEALERENGG",

  // DEALER MODULE
  VIEWDEALERS = "VIEWDEALERS",
  VERIFYADL = "VERIFYADL",
  ADDDEALERS = "ADDDEALERS",
  EDITDEALERS = "EDITDEALERS",
  DELETEDEALERS = "DELETEDEALERS",
  BULKUPLOADDEALERS = "BULKUPLOADDEALERS",

  // SERVICE REQUEST MODULE
  ADDSERVICEREQUEST = "ADDSERVICEREQUEST",
  EDITREQUEST = "EDITREQUEST",
  DELETEREQUEST = "DELETEREQUEST",
  BULKUPLOADREQUEST = "BULKUPLOADREQUEST",
  AMCAPPROVER = "APPROVEAMC",
  APPROVEWARRANTY = "APPROVEWARRANTY",
  APPROVESPARES = "APPROVESPARES",
  REJECTSPARES = "REJECTSPARES",
  VIEWSPARESPENDING = "VIEWSPARESPENDING",
  REASSIGNENGINEER = "REASSIGNENGINEER",
  SPAREDISPATCHED = "SPAREDISPATCHED",
  SERVICEREQUESTFORWARD = "SPAREREQUESTFORWARD",

  // USER - CUSTOMER MODULE
  ADDEDITCUSTUSERS = "ADDEDITCUSTUSERS",
  VIEWCUSTUSERS = "VIEWCUSTUSERS",
  DELETECUSTUSERS = "DELETECUSTUSERS",

  // USER - PARTNER MODULE
  ADDEDITPARTUSERS = "ADDEDITPARTUSERS",
  VIEWPARTUSERS = "VIEWPARTUSERS",
  DELETEPARTUSERS = "DELETEPARTUSERS",

  // USER - IDEX MODULE
  ADDEDITIDEXUSERS = "ADDEDITIDEXUSERS",
  VIEWIDEXUSERS = "VIEWIDEXUSERS",
  DELETEIDEXUSERS = "DELETEIDEXUSERS",

  ADDUSERS = "ADDUSERS",
  ADDROLES = "ADDROLES",

  // CONFIGURATION - STATUS REASON MODULE
  VIEWSTATUSREASON = "VIEWSTATUSREASON",
  ADDSTATUSREASON = "ADDSTATUSREASON",
  EDITSTATUSREASON = "EDITSTATUSREASON",
  DELETESTATUSREASON = "DELETESTATUSREASON",

  // CONFIGURATION - CONFIG GROUP MODULE
  VIEWCONFIGGROUP = "VIEWCONFIGGROUP",
  ADDCONFIGGROUP = "ADDCONFIGGROUP",
  EDITCONFIGGROUP = "EDITCONFIGGROUP",
  DELETECONFIGGROUP = "DELETECONFIGGROUP",

  // CONFIGURATION - CONFIG PARAM MODULE
  VIEWCONFIGPARAM = "VIEWCONFIGPARAM",
  ADDCONFIGPARAM = "ADDCONFIGPARAM",
  EDITCONFIGPARAM = "EDITCONFIGPARAM",
  DELETECONFIGPARAM = "DELETECONFIGPARAM",

  // CONFIGURATION - CONFIG CATEGORY MODULE
  VIEWCONFIGCATEGORY = "VIEWCONFIGCATEGORY",
  ADDCONFIGCATEGORY = "ADDCONFIGCATEGORY",
  EDITCONFIGCATEGORY = "EDITCONFIGCATEGORY",
  DELETECONFIGCATEGORY = "DELETECONFIGCATEGORY",

  // CONFIGURATION - STATE CONF MODULE
  VIEWSTATECONFIGRATION = "VIEWSTATECONFIGURATION",
  UPDATEALIAS = "UPDATEALIAS",

  // CONFIGURATION - CONFIG SPARE MODULE
  VIEWCONFIGSPARE = "VIEWCONFIGSPARE",
  ADDCONFIGSPARE = "ADDCONFIGSPARE",
  EDITCONFIGSPARE = "EDITCONFIGSPARE",
  DELETECONFIGSPARE = "DELETECONFIGSPARE",

  // CONFIGURATION - CONFIG PRODUCT LIST
  VIEWCONFIGPRODUCT = "VIEWCONFIGPRODUCT",
  ADDCONFIGPRODUCT = "ADDCONFIGPRODUCT",
  EDITCONFIGPRODUCT = "EDITCONFIGPRODUCT",
  DELETECONFIGPRODUCT = "DELETECONFIGPRODUCT",

  //  REPORTS - REPORT FORM
  VIEWREPORTLIST = "VIEWREPORTS",
  DOWNLOADSLAREPORT = "DOWNLOADSLAREPORT",
  DOWNLOADSERVICEINSTALLATIONREPORT = "DOWNLOADSERVICEINSTALLATIONREPORT",
  DOWNLOADYEARLYDEALERREPORT = "DOWNLOADYEARLYDEALERREPORT",
  DOWNLOADDEALERACTIVEASSETREPORT = "DOWNLOADDEALERACTIVEASSETREPORT",
  REPORTDOWNLOAD = "REPORTDOWNLOAD", // will not required in future

  // SCHEUDLE MODULE
  VIEWSCHEDULELIST = "VIEWSCHEDULELIST",
  CREATESCHEDULE = "CREATEREPORTSCHEDULE",
  DELETESCHEDULE = "DELETESCHEDULE",
}

export enum eRoles {
  SERVICEENGINEER = "SERVICEENGINEER",
  SERVICECORDINATOR = "SERVICECORDINATOR",
  SERVICEESCALATION = "SERVICEESCALATION",
}

export enum eTICKETSTATUSUNIQUEID {
  NEWINSTALLATION = "NEW I_b868fe75-1095-415a-b8ef-3d07570d274b",
  SERVICE_ENGG_ASSIGNED = "SERVICEEN_212ac963-eac3-4b71-92f6-e326dc273480",
  IN_PROGRESS = "INPROGRES_e2257843-0ab3-4b61-81e7-aaafbe99b464",
  VISIT_SCHEDULED = "VISITSCHE_d6f8a6fb-0e97-49c3-a467-2d9f6aa5b1e3",
  HOLD_DEALER_DEPENDENCY = "HOLD-DEA_0f1a2fa6-19cf-486c-b808-a68c4626f176",
  HOLD_SPARE_DEPENDENCY = "HOLD-SPA_4636b3c3-3d66-4da7-83d7-bcb1785a8f6e",
  HOLD_AMC_SPARE_DEPENDENCY = "HOLD-AMC_9dbe9aa8-4ff1-4c6a-acbe-9f98bcae58d0",
  HOLD_AMC_APPROVAL_PENDING = "HOLD-AMC_d75af08c-6c53-4bcb-b8ed-52f509f95b48",
  HOLD_SPARES_APPROVAL_PENDING = "HOLD-SPA_31a979d3-49fe-46d7-a7fd-3dda65b8471d",
  UNASSIGNED = "UNASSIGNED_bb65bda2-1bbd-4f1e-81c6-5bbb4df7b3b3",
  CLOSE = "CLOSE_247ed94a-7907-45a0-a90b-8d9a3f9c778a",
  FORCE_CLOSED = "FORCECLOS_785218b3-784a-498e-8c7f-bc06597c2c9f",
  SPARE_REQUEST_FORWARD = "SPARESREQ_5cacc0f3-3c39-464e-9ea6-da8dcf561699",
  SPARE_DISPATCHED = "SPARESDIS_5e712ade-e494-47b1-8078-74510805eeed",
  SPARE_APPROVED = "HOLD-SPA_a5d160d4-c8b8-4239-a19f-9f5a80873fa6",
}

export enum eDEALER_VIEW_TYPE {
  ACTIVEDEALERLIST = 1,
  DEALERPARTNERMAPPING = 2,
  ANYDEALERLIST = 3,
}

export enum eMAPPED_DEALER_VIEW {
  MAPPEDDEALER = 1,
  UNMAPPEDDEALER = 2,
}

export enum eBULKUPLOADTEMPLATE {
  ACTIVEDEALERTEMPLATE = 1,
}

export enum eENTITY {
  CUSTOMER = "CUSTOMER",
  SERVICEPARTNER = "SERVICEPARTNER",
}

export enum eREPORT {
  REPORTLIST = "REPORTLIST",
  SCHEDULELIST = "SCHEDULELIST",
}

export enum eCONFIGURATION {
  // CONFIGGROUP = "CONFIGGROUP",
  // CONFIGPARAM = "CONFIGPARAM",
  STATUSREASON = "STATUSREASON",
  STATECONFIGURATION = "STATECONFIGURATION",
  CONFIGCATEGORY = "CONFIGCATEGORY",
  CONFIGSPARE = "CONFIGSPARE",
  CONFIGPRODUCT = "CONFIGPRODUCT",
}

export enum eOTHERREQUESTTYPE {
  PM = 1,
  GDATA = 2,
  CHECKCALIBRATION = 3,
  GENERAL = 4,
}

export enum eSERVICEREQUEST {
  NEWINSTALLATION = 1,
  SERVICEREQUEST = 2,
  OTHER = 3,
}

export enum eTICKETTYPE {
  NEWINSTALLATION = 1,
  SERVICEREQUEST = 2,
  AMCAPPROVAL = 3,
  OTHER = 5,
  ALL = 0,
  CLOSE = 7,
}

export enum eAMCAPPROVALSTATUS {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}

export enum eColumnConfigKeys {
  RoleList = "roleListColumns",
  LogList = "logListColumns",
  CustomerList = "customerListColumns",
  ServicePartnerList = "servicePartnerListColumns",
  DealerList = "dealerListColumns",
  EngMappingList = "engMappingListColumns",
  TicketList = "ticketListColumns",
  ConfigGroupList = "configGroupListColumns",
  ConfigParamList = "configParamListColumns",
  ConfigCategoryList = "configCategoryListColumns",
  ConfigProductList = "configProductListColumns",
  ConfigSpareList = "configSpareListColumns",
  ConfigStateList = "configStateListColumns",
  UserList = "userListColumns",
}

export enum eMappedDealerEnum {
  MappedDealer = "1",
  UnMappedDealer = "2",
}

// FONT FAMILY
export enum eFONTFAMILY {
  REGULAR = "Montserrat-Regular",
  SEMIBOLD = "Montserrat-SemiBold",
  MEDIUM = "Montserrat-Medium",
}

export enum eTICKETCLOSINGMODE {
  ONLINESUPPORT = 1,
  INPERSONSUPPORT = 2,
}

export enum eLOCATIONTYPE {
  LOCAL = "LOCAL",
  REMOTE = "REMOTE",
  UPCOUNTRY = "UPCOUNTRY",
}

export enum eSCHEDULETYPE {
  DAILY = 1,
  WEEKLY = 2,
  MONTHLY = 3,
  ANNUAL = 4,
}

export enum eWEEKDAYS {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export const scheduleTypeMapping = {
  [eSCHEDULETYPE.DAILY]: "DAILY",
  [eSCHEDULETYPE.ANNUAL]: "ANNUAL",
  [eSCHEDULETYPE.MONTHLY]: "MONTHLY",
  [eSCHEDULETYPE.WEEKLY]: "WEEKLY",
};

export const weekDaysMapping = {
  [eWEEKDAYS.SUNDAY]: "SUNDAY",
  [eWEEKDAYS.MONDAY]: "MONDAY",
  [eWEEKDAYS.TUESDAY]: "TUESDAY",
  [eWEEKDAYS.WEDNESDAY]: "WEDNESDAY",
  [eWEEKDAYS.THURSDAY]: "THURSDAY",
  [eWEEKDAYS.FRIDAY]: "FRIDAY",
  [eWEEKDAYS.SATURDAY]: "SATURDAY",
};

export enum eMONTHMAPPING {
  STARTOFMONTH = 1,
  MIDOFMONTH = 15,
  ENDOFMONTH = 31,
}

export const monthMapping = {
  [eMONTHMAPPING.STARTOFMONTH]: "Start of Month",
  [eMONTHMAPPING.MIDOFMONTH]: "Mid of Month",
  [eMONTHMAPPING.ENDOFMONTH]: "End of Month",
};

export const eLANGUAGE = {
  ENGLISH: 1,
  SANSKRIT: 2,
  HINDI: 3,
};

export const eLOGINMODE = {
  PASSWORD: 1,
  OTP: 2,
};

export const eROLETYPE = {
  ADMIN: 1,
  USER: 2,
};

export const eUSER_FORM_TYPE = {
  ALL: 0,
  TEACHER: 1,
  STUDENT: 2,
  SCHOOL: 3,
  REGISTERED: 4,
};

export const eUSER_FORM_TYPE_NAME: { [key: number]: string } = {
  0: "ALL",
  1: "TEACHER",
  2: "STUDENT",
  3: "SCHOOL",
};

export const eFORM_FOR = {
  YOURSELF: 1,
  OTHER: 2,
};

export const eFORMSTATUS = {
  REGISTERED: 0,
  STAGE1INPROGRESS: 1,
  STAGE1SUBMITTED: 2,
  STAGE1REJECTED: 3,
  STAGE1APPROVED: 4,
  STAGE2INPROGRESS: 5,
  STAGE2SUBMITTED: 6,
  STAGE2REJECTED: 7,
  STAGE2APPROVED: 8,
  INTERVIEWSTAGE: 9,
  STAGE2SELECTED: 10,
};

export const eTimeline = {
  PT1_SUBMISSION: "PT1_SUBMISSION",
  PT1_APPROVAL: "PT1_APPROVAL",
  PT2_SUBMISSION: "PT2_SUBMISSION",
  PT2_APPROVAL: "PT2_APPROVAL",
  INTERVIEW_STAGE: "INTERVIEW_STAGE",
  SELECTION_DATE: "SELECTION_DATE",
  AWARD_DATE: "AWARD_DATE",
};

export const eSTAGE = {
  STAGE1: 1,
  STAGE2: 2,
};

export const eFormAction = {
  APPROVE: 1,
  REJECT: 2,
  SELECT: 3,
};

export const eSTAPPER_STATUS: { [key: string]: any } = {
  DONE: "finish",
  REJECT: "error",
  DUE: "process",
  IN_PROGRESS: "wait",
};

export const eFullTimeOrPartTime = {
  FULLTIME: "FullTime",
  PARTTIME: "PartTime",
};

export const eYES_OR_NO = {
  YES: "YES",
  NO: "NO",
};

export const eAnswerType = {
  TEXT: 1,
  DATE: 2,
  ARRAY: 3,
  OBJECT: 4,
  FILE: 5,
};
